import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { object, string } from 'yup'
import { Form } from 'semantic-ui-react'
import { useValidateForm } from '../../Common/Hooks/useValidateForm'
import { setSerieData } from '../Slice/SerieSlice'

export default function SerieForm () {
  const { t } = useTranslation()
  const { form: serie, isLoading, isDirty } = useSelector((state) => state.serie)
  const dispatch = useDispatch()

  const serieSchema = object({
    name: string().required(t('generic.validation.name'))
  })
  const [errors, validate, handleChange] = useValidateForm(serie, serieSchema)

  const updateFormData = (data, isValid) => {
    dispatch(setSerieData({ data, isValid }))
  }

  useEffect(() => {
    validate(serie)
  }, [isDirty])

  return (
    <Form autoComplete='off' loading={isLoading}>
      <Form.Input
        label={ t('generic.name') }
        placeholder={ t('generic.name') }
        name='name'
        required
        value={serie.name}
        error={isDirty && errors.name}
        onChange={ handleChange(updateFormData) } />
    </Form>
  )
}
